/**
 * DistributorsCtrl controller
 * Show all distributors
 */

import { getName, getNetwork, remove, unique, keyValue } from 'app/helpers/entity'

// controller mixins
DistributorsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * DistributorsCtrl controller
 *
 * @class DistributorsCtrl
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc controller
 * @name mwApp/partners.controller:DistributorsCtrl
 */
/* @ngInject */
export default function DistributorsCtrl ($scope, $location, $uibModal, historySvc, Network, Distributor) {
  var vm = this
  var search = $location.search()
  var searchNetworks = search.networks
  var searchQ = search.q

  vm.isFound = true
  vm.distributorsNetworks = []
  vm.distributorsNetworksCount = 0
  vm.total = 0
  vm.showNetworkNames = ht => vm.distributorsNetworks.length && vm.distributorsNetworks[0] &&
                              ht && ((ht.networks && ht.networks.length) || (ht.q && ht.q.length))

  vm.showVoucherBatchCreateButton = (distributor) =>
    !!vm.extraNetworks
      .filter(network => network.id === distributor.network.id && network.voucherSubscribersAllowed)
      .length

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  vm.loading = true

  /**
   * Networks list,
   * Array of {key, value} objects
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   * @type {Object[]}
   */
  vm.networks = []

  /**
   * Original networks list.
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   * @type {Object[]}
   */
  vm.extraNetworks = []

  // load networks for filter
  Distributor.loadExtra()
    .then(
      data => {
        vm.extraNetworks = data.networks
        vm.networks = data.networks.map(keyValue())
        $scope.loading = false
        vm.loading = false
      }
    )

  /**
   * Distributors list
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   * @type {models.Distributor[]}
   */
  vm.allDistributors = []

  /**
   * Get Distributors from backend
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getDistributors = function (tableState) {
    // set default sort by firstName
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'firstName'
      tableState.sort.reverse = false
    }

    // add external and startup filter to predicateObject
    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    if (searchNetworks) {
      pObject.networks = searchNetworks.split(',').map(Number)
      searchNetworks = null
    }
    if (searchQ) {
      pObject.q = searchQ
      searchQ = null
    }

    // set q and networks to navigation bar
    $location.search('q', pObject.q ? pObject.q : null)
    $location.search('networks', pObject.networks && pObject.networks.length ? pObject.networks.join(',') : null)

    // save history state
    historySvc.push()

    // get subscribers
    Distributor.loadSmart(tableState)
      .then(data => {
        if ($location.$$search.networks) {
          vm.firstLoad = false
        }
        if (vm.firstLoad === undefined) {
          vm.firstLoad = true
        } else if (vm.firstLoad) {
          vm.firstload = false
        }
        vm.allDistributors = data.content
        vm.isFound = !!vm.allDistributors.length

        // get subscribers networks
        vm.distributorsNetworks = vm.allDistributors
          .map(getNetwork)
          .filter(unique)
          .map(getName)
        vm.distributorsNetworks.sort()
        vm.total = data.totalElements

        // get count of found networks
        vm.distributorsNetworksCount = (data.raw && data.raw.totalPackage) || vm.distributorsNetworks.length
      })
  }

  /**
   * Create new voucher
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   * @param  {models.Distributor} distributor
   */
  vm.addVoucher = function (distributor) {
    $uibModal.open({
      templateUrl: 'components/partners/views/addVoucherBatch.html',
      controller: 'AddVoucherBatchCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        distributor: () => distributor
      }
    })
  }

  /**
   * Delete distributor
   *
   * @memberof mwApp/partners.controller:DistributorsCtrl
   */
  vm.delete = function (distributor) {
    distributor._delete(`${distributor.email} Distributor deleted`)
      .then(remove(vm.allDistributors)(distributor))
  }

  /**
   * Generate link to subscribers
   * @param distributor
   * @param status
   * @returns {string}
   */
  vm.generateLinkSubscribers = function (distributor, statuses) {
    let link = 'subscribers'

    if (distributor.id) {
      link += `?distributor=${distributor.id}`

      if (statuses && statuses.length) {
        link += `&statuses=${statuses.join(',')}`
      }
    }

    return link
  }
}
